import React from "react";
import "./App.css";
import Lists from "./components/Lists/Lists";

function App() {
  return (
    <div className="App">
      <Lists></Lists>
    </div>
  );
}

export default App;
